import React, { useEffect, useState } from "react";
import DashboardStatCard from "../../../components/Cards/Dashboard/DashboardStatCard";
import DotsSpinner from "../../../components/Loader/DotsSpinner/DotsSpinner";
import { getPercentage, TypeStudentOverview } from "../Hooks/useStateAdmin";
import { useHistory } from "react-router-dom";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import { CSVLink } from "react-csv";
import { STATE_OFFICIAL_PATHS } from "../../../routes";
import { IEAdhigamData, IOverAllStudent, ITypeForTopTen } from "../../../types";
import CommaSeparator from "../../../components/utils/utility/CommaSeparator/CommaSeparator";
import { calculateDataUsingDivision } from "../../../utilityFunctions";

type Props = {
  // stats: TypeStudentOverview;
  stats: IOverAllStudent;
  isLoading: boolean;
  isAdhigamLoading: boolean;
  district: string;
  EAdhigamData: IEAdhigamData;
  block?: string;
  averageCriteria: "total" | "active";
  handleClick? : (e:ITypeForTopTen)=>void
};

const StudentUsage = ({
  stats,
  EAdhigamData,
  isLoading,
  district,
  isAdhigamLoading,
  block,
  averageCriteria,
  handleClick
}: Props) => {
  const history = useHistory();


  return (
    <>
      <div className="bg-primary  py-1 rounded flex-centered mt-4">
        <h3 className="text-white m-0">Student Usage</h3>
      </div>
      {isLoading ? (
        <DotsSpinner />
      ) : (
        <div className=" d-flex flex-column">
          <div className="my-2 ml-1">
            {/* <div className="bg-light opacity-50  rounded text-whit flex-centered px-1 py-3 ">
              <span className="title font-weight-bold">Student Usage</span>
            </div> */}
            <div
              className=" d-flex flex-column justify-content-between mt-3"
              style={{ gap: "10px" }}
            >
              <DashboardStatCard
                title={"Total Students"}
                stats={
                  stats?.Total_Student
                    ? CommaSeparator(stats?.Total_Student)
                    : "0"
                }
                icon={""}
              />
              <DashboardStatCard
                // stats={`${stats?.count_students_count_lt_1hr} (${Math.ceil(+stats?.students_count_lt_1hr)}%)`}
                stats={
                  EAdhigamData?.total_adhigam_students && stats?.ActiveStudent
                    ? `${CommaSeparator(+EAdhigamData?.total_adhigam_students)} (${calculateDataUsingDivision(
                      +EAdhigamData?.total_adhigam_students,
                      averageCriteria === "active" ? +stats?.ActiveStudent : +stats?.Total_Student
                    )} %)`
                    : "0 (0.00%)"
                }
                title={"e-Adhigam Students"}
                icon={""}
              />
              <DashboardStatCard
                title={"Average Weekly Usage (in mins)"}
                stats={
                  stats?.Total_Usage && stats?.Total_Student ?(stats?.Total_Usage / stats?.Total_Student ).toFixed(2) : "0"
                }
                icon={""}
                onClick ={()=>handleClick({for:"student",type:"total_usage"})}
              />
               <DashboardStatCard
                title={"Number of Remedial Tests Taken Per Student"}
                stats={
                  stats?.Total_Remedial && stats?.Total_Student ? (+stats?.Total_Remedial / +stats?.Total_Student).toFixed(2)
                 : "0"
                }
                // stats={
                //   stats?.Total_Remedial ? `${+stats.Total_Remedial} (${calculateDataUsingDivision(
                //     +stats?.Total_Remedial,
                //     averageCriteria === "active" ? +stats?.ActiveStudent : +stats?.Total_Student
                //   )})` : "0"
                // }
                icon={""}
                onClick ={()=>handleClick({for:"student",type:"remedial"})}
              />
              <DashboardStatCard
                title={"Number of Homework Attempted per Student"}
                stats={
                  stats?.Total_Assessments && stats?.Total_Student ? (+stats?.Total_Assessments / + stats?.Total_Student).toFixed(2) : "0"
                  // stats?.Total_Assessments ? `${+stats.Total_Assessments} (${calculateDataUsingDivision(
                  //   +stats?.Total_Assessments,
                  //   averageCriteria === "active" ? +stats?.ActiveStudent : +stats?.Total_Student
                  // )})` : "0"
                }
                icon={""}
                onClick ={()=>handleClick({for:"student",type:"assessments"})}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentUsage;
